import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicableTableSettings, codesOtherShipmentTypeList } from '../../../tableSettings';
import useFastStorage from '../../../hooks/useFastStorage';
import useFunction from '../../../hooks/useFunction';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../ApplicationContext';
import { Portal } from 'react-portal';
import { Search, getInitialSearch } from '../../../filtering';
import { CodeOtherOPCategoryListItem } from '../../../fms.data/models/CodeOtherOPCategoryListItem';
import { JobNames } from '../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../framework.core/data/ApiResult';
import { SQLType } from '../../../framework.core/data/SQLInfo';
import TextBox from '../../../ui/TextBox';
import EditableTable, { CellData, TableCellTypes } from '../../../ui/tables/editing/EditableTable';
import { FmsSecTask } from '../../../fms.core/constants';
import GreenButton from '../../../ui/GreenButton';
import { checkTabIsDirty } from '../ReferenceFiles';
import { duplicateCell, findSecurityTask } from '../../../util';
import BlackInverseButton from '../../../ui/BlackInverseButton';
import constants from '../../../constants';
import IFmsReferenceFilesContext from '../IfmsReferenceFilesContext';
import CloseButton from '../../../ui/CloseButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import { RefreshIconButton2 } from '../../../ui/IconButton';

function TypeRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <TextBox textId={`type-${row.index}`} maxLength={10} value={l.type} onChange={e => changeLineItem(row.index, {type: e.target.value, isUpdate:true})} />
  );
}

function DescriptionRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <TextBox textId={`description-${row.index}`} maxLength={30} value={l.description} onChange={e => changeLineItem(row.index, {description: e.target.value, isUpdate:true})} />
  );
}

function PrefixRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <TextBox textId={`prefix-${row.index}`} maxLength={10} value={l.prefix} onChange={e => changeLineItem(row.index, {prefix: e.target.value, isUpdate:true})} />
  );
}

function NoRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <TextBox textId={`no-${row.index}`} maxLength={10} value={l.no} onChange={e => changeLineItem(row.index, {no: e.target.value, isUpdate:true})} />
  );
}


function formatElement(data:any) {
  const result = new CodeOtherOPCategoryListItem();
  result.type = data.type;
  result.description = data.description;
  result.prefix = data.prefix;
  result.no = data.no;
  result.cid = data.cid;
  result.isNew = false;
  return result;
}

function formatData(data:Array<any>) {
  return data.map(d => formatElement(d));
}

function OtherShipmentTypes() {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
    //ifmsReferenceFilesCancel: () => {},
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, /*dataRef*/] = useFastStorage(`ifms-referenceFiles-ostype-list`, []);

  const savedDataRef = useRef<Array<CodeOtherOPCategoryListItem>>([]);
  const oriData = useRef<CodeOtherOPCategoryListItem[]>([]);
  //const addingToTheFirstLine = useRef(false);

  const tableHeight = 520;
  const listSec = findSecurityTask(appContext,  FmsSecTask.CodeOtherOPType);
  const [focusFirstCell, setFocusFirstCell] = useState({ dataLength: 0, focus: false });

  const listItemType = 'CodeOtherOPCategoryListItem';
  
  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }
  
  function cancelOperation() {
    setHasChanges(false);
    removeData();
    return true;
  }
  
  function setData(d:Array<any>, callByFetchData: boolean = false) {
    setFocusFirstCell({ dataLength: d.length, focus: callByFetchData });
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeOtherOPCategoryListItem, oriData.current, d));
  }

  async function fetchData(api:any,search:Search) {
    setLoading(true);
    //<pt220818: portal
    //const apiResult = await api.getCodesOtherShipmentTypes();
    //setData(formatData(apiResult || []));
    const searchModel = CodeOtherOPCategoryListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.OtherOP,
      listItemType, searchModel, 1, search.pageSize);
    const data = apiResult && apiResult.entities ? apiResult.entities : [];

    oriData.current = formatData(data);
    setData(formatData(data), true);

    savedDataRef.current = data;
    //pt220818>
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (data.length === 0)
      reload();
    else {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  function reload() {
    fetchData(appContext.api, getInitialSearch());
  }


  function deleteRow(index: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[index];

    if (!element.isNew) {

      let deleteRow = savedDataRef.current.find(x => x.type === element.type);
      if (deleteRow) {
        deleteRow.isDelete = true;
      }
    }

    data.splice(index, 1);

    setData(data);

    return true;
  }

  function applyToLineItem(rowIndex: number, change: Partial<CodeOtherOPCategoryListItem> | null) {
    if (!change || !data) {
      return;
    }
    const checkData = data[rowIndex];
    if (!change.isNew && (change.type !== checkData.type || change.description !== checkData.description || change.no !== checkData.no || change.prefix !== checkData.prefix)) {
      _.merge(data[rowIndex], { ..._.omit(change, ['isNew']), hasBeenChanged: true });
      setData(data);
      //setHasChanges(true);
    }
  }

  function addLineItem() {
    const newItem = new CodeOtherOPCategoryListItem();
    newItem.type = '';
    newItem.description = '';
    newItem.prefix = '';
    newItem.no = '';
    newItem.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newItem
    };
  }

  async function save() {
    if (!data) {
      return;
    }

    let validData = data.filter((x:any) => x.type);

    let errMsg = '';
    const dataToSave = validData.filter((x: any) => x.isNew || x.hasBeenChanged === true); // new data is always last so index check works
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload();
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      //window.console.log(s);
      if (!apiResult || !apiResult.success)
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }


    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave, data, appContext, listItemType, showGlobalOkDialog, JobNames.OtherOP, 'type');
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeOtherOPCategoryListItem) => a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeOtherOPCategoryListItem) => cidData.includes(x.type.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeOtherOPCategoryListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);

        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.type === x.type);
            if (index >= 0) {
              data[index].cid = x.type;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          });
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);

        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.type === x.type);
            if (index >= 0) {
              data[index].cid = x.type;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          });
        }
      }
    }

    if (errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }

    // setData(data);
    // savedDataRef.current = _.cloneDeep(data);
    // oriData.current = _.cloneDeep(data);
    
    // setLoading(false);
    // setHasChanges(false);
    reload();

    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-ostype-list',
    tableName: 'osTypeList',
    ...codesOtherShipmentTypeList,
    height: `${tableHeight}px`,
    data: (data ?? []).map((x:any) => ({...x, changeLineItem: applyToLineItem})),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'type',  EditCell: TypeRenderer },
      { accessor: 'description',  EditCell: DescriptionRenderer },
      { accessor: 'prefix',  EditCell: PrefixRenderer },
      { accessor: 'no', EditCell: NoRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'type')
        return { type: TableCellTypes.Text, value: data[rowIndex].type };
      else if (accessor === 'description')
       return { type: TableCellTypes.Text, value: data[rowIndex].description };
      else if (accessor === 'prefix')
        return { type: TableCellTypes.Text, value: data[rowIndex].prefix };
      else if (accessor === 'no')
        return { type: TableCellTypes.Text, value: data[rowIndex].no };
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },

    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
    //useTableHelperText: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const otherShipmentCount = data ? data.length : 0;

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Other Shipment Type</h1>
      </Portal> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', width: '100px'}}>
          <div className="ifms-common-bar-element-center">
            <GreenButton size="regular" disabled={loading} onClick={save}><span style={{ textDecoration: 'underline' }}>S</span>ave</GreenButton>
          </div>
          <div style={{margin:'auto'}}></div>
          <div className="ifms-common-bar-element-center">
            <CloseButton onlyIcon name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      {/* <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click Other Shipment Type to Edit
          </div> */}
      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          {//<SecondaryButton name='codes-othershipment-type-add-button' size="regular" disabled={!listSec?.grantAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; 
          }
          {/* <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload() }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton> */}
          <RefreshIconButton2 name='list-screen-refresh' onClick={() => { reload() }} disabled={loading} data-tooltip="Refresh"/>
        </div>
      </div>

      <div style={{ width: '864px' }}>
        <EditableTable
          tableOptions={tableOptions}
          deleteLine={deleteRow}
          addLine={addLineItem}
          canDeleteRow={rowNumber => listSec?.grantDel ?? false}
          initializeFocusedCell={focusFirstCell}
        />
      </div>
    </div>
  );
}

export default OtherShipmentTypes;